// extracted by mini-css-extract-plugin
module.exports = {"content":"paymentSuccess_content__HRcXo","image":"paymentSuccess_image__VWodj","text":"paymentSuccess_text__14NsM","btn":"paymentSuccess_btn__3lXnS"};